import { Component, forwardRef } from '@angular/core';
import { teamHeroSources } from '../../component/team-hero-sources';
import { combineLatest, Observable, of } from 'rxjs';
import { JongereProfiel } from '../../../profiel/model/profiel';
import { ActivatedRoute } from '@angular/router';
import { GeblokkeerdMelding, validatedProfielId } from 'parkour-web-app-dto';
import { AangemeldeUser } from '../../../authentication/user';
import { meldingenForWisselTeamPage } from '../../../meldingen/config';
import { TeamService } from '../../service/team.service';
import { TranslateModule } from '@ngx-translate/core';
import { ParkourBackButtonDirective } from '../../../shared/directives/parkour-back-button.directive';
import {
  ParkourDividerComponent,
  ParkourHeroComponent,
  ParkourInfoCardComponent,
  ParkourPageGradientComponent,
  ParkourPageImageComponent,
} from '@parkour/ui';
import { AsyncPipe } from '@angular/common';
import { ParkourProfielBlockComponent } from '../../../shared/components/parkour-profiel-block/parkour-profiel-block.component';
import { PageContentDirective } from '../../../shared/directives/page-content.directive';
import { PageLayoutComponent } from '../../../shared/components/page-layout/page-layout.component';
import { TeamVerlatenSectionComponent } from '../../component/team-verlaten-section/team-verlaten-section.component';
import { getProfielnaam } from '../../../profiel/model/profiel-in-team';
import { ParkourDataPage } from '../../../shared/parkour-data-page';
import {
  IonBackButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonRefresher,
  IonRefresherContent,
  IonTitle,
  IonToolbar,
} from '@ionic/angular/standalone';
import { ParkourRefreshDirective } from '../../../shared/directives/parkour-refresh-directive';
import {
  MarksMeldingenAsReadOnView,
  MeldingenToMarkAsRead,
} from '../../../shared/marks-meldingen-as-read';
import { CustomPageTitle } from '../../../shared/custom-page-title';
import AuthService from '../../../authentication/service/auth.service';

export type GeblokkeerdTeamPageData = {
  jongere: JongereProfiel;
  user: AangemeldeUser;
};

@Component({
  standalone: true,
  templateUrl: './geblokkeerd-team.page.html',
  imports: [
    ParkourBackButtonDirective,
    TranslateModule,
    ParkourPageImageComponent,
    ParkourPageGradientComponent,
    AsyncPipe,
    ParkourHeroComponent,
    ParkourDividerComponent,
    ParkourInfoCardComponent,
    ParkourProfielBlockComponent,
    forwardRef(() => PageContentDirective),
    PageLayoutComponent,
    TeamVerlatenSectionComponent,
    IonRefresher,
    IonRefresherContent,
    IonBackButton,
    ParkourRefreshDirective,
    IonContent,
    IonTitle,
    IonButtons,
    IonToolbar,
    IonHeader,
  ],
})
export class GeblokkeerdTeamPage
  extends ParkourDataPage<GeblokkeerdTeamPageData>
  implements MarksMeldingenAsReadOnView, CustomPageTitle
{
  protected readonly teamHeroSources = teamHeroSources;

  constructor(
    private readonly teamService: TeamService,
    private readonly authService: AuthService,
    private readonly activatedRoute: ActivatedRoute,
  ) {
    super();
  }

  override retrieveMainData(): Observable<GeblokkeerdTeamPageData> {
    return combineLatest({
      jongere: this.teamService.getJongere(
        validatedProfielId(this.activatedRoute.snapshot.paramMap.get('jongereId')),
      ),
      user: this.authService.getAangemeldeUser$(),
    });
  }

  getMeldingenToMarkAsRead() {
    return of(
      new MeldingenToMarkAsRead(
        meldingenForWisselTeamPage.GEBLOKKEERD_TEAM_PAGE.specificMeldingen,
        (melding: GeblokkeerdMelding) =>
          melding.metaData.jongereProfielId ===
          validatedProfielId(this.activatedRoute.snapshot.paramMap.get('jongereId')),
      ),
    );
  }

  getCustomPageTitle() {
    return this.generateDefaultTitle(
      (data) => getProfielnaam(data.jongere),
      'team.geblokkeerd-team.title',
    );
  }
}
